<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M4 2h16q.9 0 1.4.6.6.6.6 1.4v11q0 .8-.6 1.4a2 2 0 0 1-1.4.6h-4v5l-4-2-4 2v-5H4a2 2 0 0 1-1.4-.6A2 2 0 0 1 2 15V4q0-.8.6-1.4A2 2 0 0 1 4 2m0 11h16v-3H4z"
    />
  </svg>
</template>
